"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nullableGet = exports.strictGet = exports.strictGetValue = void 0;
const StrictAccessError_1 = __importDefault(require("@react/common/StrictAccessor/StrictAccessError"));
function strictGetValue(value) {
    if (value !== undefined) {
        return value;
    }
    throw new Error(`Could not access property ${value} in object`);
}
exports.strictGetValue = strictGetValue;
function strictGet(object, key) {
    if (Object.prototype.hasOwnProperty.call(object, key) && object[key] !== undefined) {
        return object[key];
    }
    throw new StrictAccessError_1.default(object, key);
}
exports.strictGet = strictGet;
function nullableGet(object, key) {
    if (Object.prototype.hasOwnProperty.call(object, key) && object[key] !== undefined) {
        return object[key];
    }
    return null;
}
exports.nullableGet = nullableGet;
